import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _reducerMap;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { handleActions } from 'redux-actions';
import actions from '../actions/catalog';
export var name = 'catalog';

var fromPairs = function fromPairs(pairs) {
  var result = {};

  var _iterator = _createForOfIteratorHelper(pairs),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];

      result[key] = value;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
};

var initialState = {
  categories: {},
  currentPage: 1,
  pageSize: 6,
  prevPageTotal: null
};
var reducerMap = (_reducerMap = {}, _defineProperty(_reducerMap, actions.updateCategories, function (state, _ref) {
  var payload = _ref.payload;
  var uid = payload.uid;
  var currentCategory = state.categories[uid] || {}; // if category has already been fetched, do nothing

  if (currentCategory.children) {
    return state;
  } // sort children by `position`


  var children = _toConsumableArray(payload.children).sort(function (a, b) {
    if (a.position > b.position) {
      return 1;
    } else if (a.position === b.position && a.uid > b.uid) {
      return 1;
    } else {
      return -1;
    }
  }); // use a Map to preserve sort order
  // since a plain object with numeric keys would lose it


  var childMap = new Map(); // merge children and add them to the Map, keyed by `id`

  var _iterator2 = _createForOfIteratorHelper(children),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var child = _step2.value;
      childMap.set(child.uid, _objectSpread({}, child, state.categories[child.uid] || {}, {
        parentId: uid
      }));
    } // merge in the fetched child last

  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return _objectSpread({}, state, {
    categories: _objectSpread({}, state.categories, fromPairs(childMap), _defineProperty({}, uid, _objectSpread({}, currentCategory, payload, {
      children: _toConsumableArray(childMap.keys()),
      children_count: childMap.size
    })))
  });
}), _defineProperty(_reducerMap, actions.setCurrentPage.receive, function (state, _ref2) {
  var payload = _ref2.payload,
      error = _ref2.error;

  if (error) {
    return state;
  }

  return _objectSpread({}, state, {
    currentPage: payload
  });
}), _defineProperty(_reducerMap, actions.setPrevPageTotal.receive, function (state, _ref3) {
  var payload = _ref3.payload,
      error = _ref3.error;

  if (error) {
    return state;
  }

  return _objectSpread({}, state, {
    prevPageTotal: payload
  });
}), _reducerMap);
export default handleActions(reducerMap, initialState);